var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 13.847q0-3.29 1.99-6.318 1.988-3.028 5.462-5.3.652-.435 1.35-.043.698.393.698 1.18v1.513q0 .99.698 1.66.697.67 1.707.67.504 0 .965-.219.459-.218.816-.626.237-.29.608-.364a.87.87 0 0 1 .698.16 9.3 9.3 0 0 1 2.94 3.349 9.2 9.2 0 0 1 1.068 4.338q0 2.563-1.277 4.674a9.5 9.5 0 0 1-3.354 3.333q.504-.698.787-1.528.282-.83.282-1.762 0-1.164-.446-2.198a5.8 5.8 0 0 0-1.276-1.849L12 10.47l-4.186 4.047a5.9 5.9 0 0 0-1.306 1.864 5.4 5.4 0 0 0-.445 2.183q0 .932.282 1.762a5.8 5.8 0 0 0 .786 1.528 9.5 9.5 0 0 1-3.354-3.333Q2.5 16.409 2.5 13.847m9.5-.116 2.523 2.417q.505.494.772 1.106.268.612.268 1.31 0 1.427-1.04 2.432Q13.485 22 12 22q-1.484 0-2.523-1.005t-1.04-2.43q0-.671.268-1.296.267-.626.772-1.121z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.f5165175940bb63172d9c210f484fafa.svg";
export { ForwardRef as ReactComponent };